import React, { useEffect } from "react";
import ReactECharts from "echarts-for-react";

const TreeMapChart2 = ({ chartData, setTreeMapPath, mPath }) => {
  // Conditional logging for debugging (remove in production)
  const processedData = chartData?.map((item) => ({
    ...item,
    displayName:
      item.name.length > 15 ? item.name.slice(0, 12) + "…" : item.name,
    displayValue:
      typeof item.value === "number" ? item.value.toLocaleString() : item.value,
  }));

  function getLevelOption() {
    return [
      {
        // Level 0: F_YEAR
        itemStyle: {
          borderColor: "rgb(80, 80, 80)",
          borderWidth: 1,
          gapWidth: 1,
        },
        upperLabel: {
          show: false,
          fontSize: 12,
          color: "white",
        },
      },
      {
        // Level 1: ASSET_GROUP
        itemStyle: {
          borderColor: "rgb(110, 110, 110)",
          borderWidth: 1,
          gapWidth: 1,
        },
        upperLabel: {
          show: true,
          fontSize: 12,
          color: "#fff",
        },
      },
      {
        // Level 2: MAIN_CAUSE_DESC
        itemStyle: {
          borderColor: "rgb(160, 160, 160)",
          borderWidth: 1,
          gapWidth: 1,
        },
        upperLabel: {
          show: true,
          fontSize: 12,
          color: "#333",
        },
      },
      {
        // Level 3: SUB_CAUSE_DESC
        itemStyle: {
          borderColor: "rgb(189, 189, 189)",
          borderWidth: 1,
          gapWidth: 1,
        },
        upperLabel: {
          show: true,
          fontSize: 12,
          color: "#333",
        },
      },
      {
        // Level 4: Month
        itemStyle: {
          borderColor: "rgb(230, 230, 230)",
          borderWidth: 1,
          gapWidth: 1,
        },
        upperLabel: {
          show: true,
          fontSize: 12,
          color: "#333",
        },
      },
    ];
  }

  const getOption = () => ({
    title: {
      left: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c}",
    },
    series: [
      {
        type: "treemap",
        data: chartData,
        visibleMin: 350,
        roam: false,
        nodeClick: "zoomToNode",
        label: {
          show: true,
          fontSize: 10,
          formatter: "{b}- {c} cause ",
        },

        levels: getLevelOption(),
        breadcrumb: {
          show: true,
          // left: "left",
          bottom: "bottom",
        },
      },
    ],
  });

  const onChartClick = (params) => {
    const levelNames = [
      "",
      "F_YEAR",
      "ASSET_GROUP",
      "MAIN_CAUSE_DESC",
      "SUB_CAUSE_DESC",
      "Month",
    ];
    const level = params?.treePathInfo?.length - 1;
    const levelName = levelNames[level] || "Unknown";
    const nodeName = params.name;
    const nodeValue = params.value || "N/A";
    const path = {};
    const levelMap = mPath
      ? mPath
      : [
          "_",
          "F_YEAR",
          "ASSET_GROUP",
          "MAIN_CAUSE_DESC",
          "SUB_CAUSE_DESC",
          "Month",
        ];
    params?.treePathInfo?.forEach((info, index) => {
      path[levelMap[index]] = info.name;
    });
    setTreeMapPath(path);
  };

  const onEvents = {
    click: onChartClick,
  };

  return (
    <div className="newUiBody">
      <ReactECharts
        option={getOption()}
        style={{ height: "400px", width: "auto" }}
        onEvents={onEvents}
      />
    </div>
  );
};

export default TreeMapChart2;
